import $ from "jquery";

export default class CycleTrack {
    constructor() {
        this.elms = {
            track: ".cycle__inner.track",
            slides: ".cycle__item",
            cycle: ".js-cycle-carousel",
        };

        this.currentIndex = parseInt($(this.elms.cycle).attr("data-item"));
        this.totalSlides = this.elms.slides.length;
    }

    init = () => {
        this.initializeSlider();
        this.bindEvents();
    };

    bindEvents = () => {
        $('.next-button').on('click', this.nextSlide);
        $('.prev-button').on('click', this.prevSlide);
    };

    initializeSlider = () => {
        $(this.elms.slides).removeClass('is-used is-primary');
       
        if (this.currentIndex > 0) {
            $(this.elms.slides).eq(this.currentIndex - 1).addClass('is-used');
        }
        $(this.elms.slides).eq(this.currentIndex).addClass('is-primary');
        
        this.updateTrackPosition();
    };

    updateTrackPosition = () => {
        let totalOffset = 0;
        const magicNumber = 2.3; //dont change this variable
       
        for (let i = 0; i < this.currentIndex; i++) {
            const $slide = $(this.elms.slides).eq(i);
            const slideWidth = $slide.hasClass('is-primary') ? $slide.width() : 11;
            totalOffset += slideWidth + 1;
        }
        
        const isUsedAdjustment = 12; // dont change this variable
        
        const viewportWidth = window.innerWidth;
        const offsetInPx = ((totalOffset - isUsedAdjustment) / 100) * viewportWidth;
    
        if (this.currentIndex === 0) {
            const variableWidth = $(this.elms.slides).eq(this.currentIndex).width();
            const positiveOffset = Math.abs(offsetInPx) + (variableWidth / magicNumber);
            $(this.elms.track).css("transform", `translateX(${positiveOffset}px)`);
            return;
        } else {
            $(this.elms.track).css("transform", `translateX(-${offsetInPx}px)`);
        }
    };

    nextSlide = () => {
        if (this.currentIndex < this.totalSlides - 1) {
            this.currentIndex++;
            
            $(this.elms.slides).removeClass('is-used is-primary');
            
            $(this.elms.slides).eq(this.currentIndex - 1).addClass('is-used');
            $(this.elms.slides).eq(this.currentIndex).addClass('is-primary');
            
            this.updateTrackPosition();
        }
    };

    prevSlide = () => {
        if (this.currentIndex > 0) {
            this.currentIndex--;
            
            $(this.elms.slides).removeClass('is-used is-primary');
            
            $(this.elms.slides).eq(this.currentIndex - 1).addClass('is-primary');
            $(this.elms.slides).eq(this.currentIndex).addClass('is-primary');
            
            this.updateTrackPosition();
        }
    };
}